import { render } from "./GoogleAd3.vue?vue&type=template&id=10ae255f"
import script from "./GoogleAd3.vue?vue&type=script&lang=js"
export * from "./GoogleAd3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__